import React, { useContext } from "react";
import { AuthContext } from "../../context/Auth";
import { Link } from "react-router-dom";
import { FaShoppingCart, FaSignOutAlt } from "react-icons/fa";
import { CartContext } from "../../context/Cart";
import { logOut } from "./../../store/Auth";
import ProfilePlacholder from "./../../media/profile/profile.svg";

const HeaderLoggedIn = ({ closeNav }) => {
  const { authState, authDispatch } = useContext(AuthContext);
  const { cartState } = useContext(CartContext);

  const logout = () => {
    authDispatch(logOut());
    window.location = "/";
  };

  return (
    <div className="header-loggedin">
      <div className="header-user user-name">
        <img
          src={authState.user.photo.url ? authState.user.photo.url : ProfilePlacholder}
          alt="user"
          className="header-user-photo"
        />
        <h3 className="header-user-name">{authState.user.firstName}</h3>

        <ul className="sub-list">
          {authState.user.role === "admin" || authState.user.role === "manager" ? (
            <li className="sub-item">
              <Link to="/manage-app/users" className="sub-link link">
                Manage Applications
              </Link>
            </li>
          ) : null}
          <li className="sub-item">
            <Link to="/view-profile" className="sub-link link">
              Preview Profile
            </Link>
          </li>

          <li className="sub-item">
            <Link to="/orders/me" className="sub-link link">
              My Orders
            </Link>
          </li>
          <li className="sub-item">
            <Link to="/edit-profile" className="sub-link link">
              Update Info
            </Link>
          </li>
          <li className="sub-item">
            <Link to="/update-password" className="sub-link link">
              Update Password
            </Link>
          </li>
        </ul>
      </div>

      <Link className="icon cart-icon" to="/cart" onClick={closeNav}>
        <span className="cart-count">
          {" "}
          <span>
            {cartState || cartState.items !== undefined ? cartState.items.length : 0}
          </span>
        </span>
        <FaShoppingCart
          size={30}
          style={{
            cursor: "pointer",
            alignSelf: "center",
            padding: ".5rem",
            // margin: ".4rem",
          }}
          color="tomato"
        />
      </Link>
      <FaSignOutAlt
        size={30}
        style={{
          cursor: "pointer",
        }}
        // className="btn-small link btn-signup"
        onClick={logout}
      ></FaSignOutAlt>
    </div>
  );
};

export default HeaderLoggedIn;
